import { create } from "zustand";

interface FilterState {
  page:number;
  surveysPage:number;
  searchValue:string;
  currentTab:number;
  setPage:(page:number)=>void
  setSurveysPage:(page:number)=>void
  setCurrentTab:(page:number)=>void
  setSearchValue:(search:string)=>void
  resetFilter:()=>void

}

export const useSurveyorsFilterStore = create<FilterState>((set) => ({
  page:1,
  surveysPage:1,
  searchValue:'',
  currentTab:0,
  setPage:(page:number)=>set({page}),
  setSurveysPage:(page:number)=>set({surveysPage:page}),
  setCurrentTab:(tab:number)=>set({currentTab:tab}),
  setSearchValue:(search:string)=>set({searchValue:search}),
  resetFilter:()=>set({page:1,searchValue:''})
}));